module.exports = __webpack_public_path__ + "static/img/20230106_01.a1f6647.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20230106_01.png
// module id = grSz
// module chunks = 0